var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details" },
    [
      _vm._m(0),
      _c("Table", {
        attrs: {
          items: _vm.updateDetails,
          attributes: _vm.tableAttributes,
          options: _vm.tableOptions
        },
        on: { head: _vm.sendLink }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "intro" }, [
      _c("h4", [_vm._v("Activity Log")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }